import setLocalStorageValue from './set-local-storage-value'

// set if we need to show the cookie popup
export default function setLocalFlagValue(flag: string, value: boolean | string): void {
  if (typeof window !== 'undefined') {
    setLocalStorageValue(flag, value.toString())
  }
}
